<template>
  <div class="slide" id="slide_final2" v-show="isVisibleSlide('final2')">
    <!-- Variant 1 -->
    <div class="slide-content">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="content-wrapper">
              <div>
                <p>Before you go...</p>
                <p><strong>Unions are only as strong as their members. Every time a new member joins, our movement becomes more powerful.</strong></p> 
                <p>Unions are there when times are tough, providing free legal advice if you need it. There are lots of discounts and offers for union members too.</p>
                <p class="highlight">More than 6 million people in the UK have joined a union - want to find out which union is right for you? </p>
              </div>
              <div class="buttons-container">
                <button class="btn btn-light red" @click="gotoUrl('join'); analytics('join a union', 'clicked yes');">YES - TELL ME MORE!</button>
                <button class="btn btn-light" @click="gotoSlide('thanks'); analytics('join a union', 'clicked no');">No, thanks</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Final2',
  props: ['gotoSlide', 'isVisibleSlide', 'analytics'],
  data () {
    return { 
    }
  },
  methods: {
    gotoUrl: function(u) {
      var url  = "https://www.megaphone.org.uk/";
      if(u == 'join'){
        url = "https://www.tuc.org.uk/join-union";
      }
      window.open(url, '_blank');
    }
  }
}
</script>

<style scoped lang="scss">
.slide-content {
  .container {
    box-shadow: 0px 0px 10px rgba(70,70,70,0.1);
    text-align: center;
    @media only screen and (max-width: 768px) {
      box-shadow: none;
    }
    .content-wrapper {
      margin: 100px auto;
      max-width: 650px;
      @media only screen and (max-width: 1100px) {
        margin: 50px auto;
      }
      @media only screen and (max-width: 768px) {
        margin: 30px auto;
      }
    }
  }
  &.variant2 {
    .container {
      box-shadow: none;
      .content-wrapper {
      }
    }
  }
  p {
    font-size: 17px;
    &.highlight {
      color: #cd171e;
      font-weight: 600;
      margin-top: 40px;
      @media only screen and (max-width: 768px) {
        margin-top: 20px;
      }
    }
    @media only screen and (max-width: 768px) {
      text-align: center;
      font-size: 14px;
    }
  }
}
.buttons-container {
  margin-top: 30px;
  @media only screen and (max-width: 768px) {
    text-align: center;
  }
  button {
    display: inline-block;
    margin: 0 10px;
    font-size: 17px;
    min-width: 230px;
    padding: 17px 35px;
    @media only screen and (max-width: 768px) {
      margin: 0 0 15px 0;
      max-width: 400px;
      width: 100%;
    }
  }
}
.btn-skip {
  margin-top: 40px;
  @media only screen and (max-width: 768px) {
    margin-top: 10px;
  }
}
</style>